var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',{attrs:{"type":"flex","justify":"start","align":"middle","gutter":16}},[_c('Col',{attrs:{"span":_vm.formSpan}},[_c('FormBox',{ref:"form",attrs:{"config":_vm.form},on:{"input":_vm.formChanged}})],1),_vm._v(" "),(_vm.operflag)?_c('Col',{attrs:{"span":_vm.btnSpan}},[_c('Button',{attrs:{"type":"default","icon":"ios-remove"},on:{"click":_vm.doDel}})],1):_vm._e()],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/layouttemplate/billconditionbox.vue